import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface WindowDTO {
  id: number;
  windowName: string;
  roomId: number;
  floorId: number;
}

interface ViewWindowModuleProps {
  show: boolean;
  onHide: () => void;
  window: WindowDTO;
}

const ViewWindowModule: React.FC<ViewWindowModuleProps> = ({ show, onHide, window }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Window Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Window Name</label>
          <input type="text" className="form-control" value={window.windowName || '-'} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Room ID</label>
          <input type="text" className="form-control" value={window.roomId} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Floor ID</label>
          <input type="text" className="form-control" value={window.floorId} disabled />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewWindowModule;